import { render } from "./PCRecuperarMercanciaVolcadaVistaUL.vue?vue&type=template&id=2004deeb"
import script from "./PCRecuperarMercanciaVolcadaVistaUL.vue?vue&type=script&lang=js"
export * from "./PCRecuperarMercanciaVolcadaVistaUL.vue?vue&type=script&lang=js"

import "./PCRecuperarMercanciaVolcadaVistaUL.vue?vue&type=style&index=0&id=2004deeb&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__